import { TAB_NAMES } from "@/organisms/Drawers/const"

export const INITIAL_STATE = {
  tooltips: {
    [TAB_NAMES.attackScenarios]: {
      disabledTooltipKey: "triage.drawer.tooltips.attackScenariosDisabled"
    },
    [TAB_NAMES.runtimeEvidence]: {
      disabledTooltipKey: "triage.drawer.tooltips.runtimeEvidenceDisabled"
    },
    [TAB_NAMES.exploitValidation]: {
      disabledTooltipKey: "triage.drawer.tooltips.exploitValidationDisabled"
    },
    [TAB_NAMES.remediation]: {
      disabledTooltipKey: "triage.drawer.tooltips.remediationDisabled"
    }
  },
  disabled: {
    [TAB_NAMES.attackScenarios]: true,
    [TAB_NAMES.runtimeEvidence]: true,
    [TAB_NAMES.exploitValidation]: true,
    [TAB_NAMES.remediation]: true
  },
  featureStatus: {
    [TAB_NAMES.attackScenarios]: "beta"
  }
}
